import { render, staticRenderFns } from "./UsersPrivilegeEmployeeOfficialHolidaysPlans.vue?vue&type=template&id=53a9b276&scoped=true&"
import script from "./UsersPrivilegeEmployeeOfficialHolidaysPlans.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeEmployeeOfficialHolidaysPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9b276",
  null
  
)

export default component.exports